import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';

const faqs = [
  {
    q: 'How long does it take to set up AinaSuite?',
    a: 'Most teams have their AI agent live in under 10 minutes. Upload your knowledge files, connect your channels and the agent starts replying immediately.',
  },
  {
    q: 'Do I need a coding team to integrate this?',
    a: 'No. AinaSuite is fully no-code — connect WhatsApp, Instagram, Telegram and Facebook via guided flows. The web chat widget is a single copy-paste snippet.',
  },
  {
    q: 'Private Channel Access (available on Enterprise Plan)',
    a: 'Yes — our Private Channel Access (Enterprise plan) restricts replies to authorised account numbers or specific users, perfect for VIP support or internal helpdesks.',
  },
  {
    q: 'Which file types can I train the AI on?',
    a: 'PDF, Word (.docx), Excel (.xlsx), CSV and TXT files — uploaded directly or synced from Google Drive. Updates re-train the AI automatically.',
  },
  {
    q: 'Does it work with WhatsApp Official API and QR Scan?',
    a: 'Both. Connect via the Official WhatsApp Business API for enterprise volume, or use QR Scan for a fast, no-paperwork start.',
  },
  {
    q: 'Can my human team take over when needed?',
    a: 'Absolutely. The Unified Inbox lets any team member jump into any conversation and reply directly, then hand back to the AI.',
  },
];

function Item({ q, a, open, onToggle }) {
  return (
    <div className={`faq__item ${open ? 'faq__item--open' : ''}`}>
      <button className="faq__q" onClick={onToggle} aria-expanded={open}>
        <span>{q}</span>
        {open ? <Minus size={18} /> : <Plus size={18} />}
      </button>
      {open && <div className="faq__a">{a}</div>}
    </div>
  );
}

export default function FAQ() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="faq">
      <div className="container faq__inner">
        <div className="faq__head reveal">
          <span className="eyebrow">FAQ</span>
          <h2 className="faq__title">Questions, answered.</h2>
          <p className="faq__desc">Still stuck? Email <a href="mailto:hello@ainasuite.com">hello@ainasuite.com</a> and a human will reply.</p>
        </div>
        <div className="faq__list">
          {faqs.map((f, i) => (
            <Item
              key={f.q}
              q={f.q}
              a={f.a}
              open={openIdx === i}
              onToggle={() => setOpenIdx(openIdx === i ? -1 : i)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
